module.exports = __webpack_public_path__ + "img/recurringOff.85bd2791.svg";